import * as echarts from "echarts";

// 개별 테마 JSON import
import verdantScentTheme from "assets/theme/echart/verdant-scent-theme.json";
import oceanGleamTheme from "assets/theme/echart/ocean-gleam-theme.json";
import lavenderBloomTheme from "assets/theme/echart/lavender-bloom-theme.json";
import appleLeavesTheme from "assets/theme/echart/apple-leaves-theme.json";
import frozenBananaTheme from "assets/theme/echart/frozen-banana-theme.json";
import plumCandyTheme from "assets/theme/echart/plum-candy-theme.json";
import dryFirewoodTheme from "assets/theme/echart/dry-firewood-theme.json";
import rainbowTheme from "assets/theme/echart/rainbow-theme.json";
import mysticDawnTheme from "assets/theme/echart/mystic-dawn-theme.json";
import roseRadianceTheme from "assets/theme/echart/rose-radiance-theme.json";
import crepeCakeTheme from "assets/theme/echart/crepe-cake-theme.json";
import bubblegumTheme from "assets/theme/echart/bubblegum-theme.json";
import warmMapleTheme from "assets/theme/echart/warm-maple-theme.json";
import urbanSkyTheme from "assets/theme/echart/urban-sky-theme.json";
import diverseFlavorsTheme from "assets/theme/echart/diverse-flavors-theme.json";
import cottonCandyTheme from "assets/theme/echart/cotton-candy-theme.json";
import tropicalFruitTheme from "assets/theme/echart/tropical-fruit-theme.json";
import markerMagicTheme from "assets/theme/echart/marker-magic-theme.json";
import colorCarnivalTheme from "assets/theme/echart/color-carnival-theme.json";
import twilightDreamsTheme from "assets/theme/echart/twilight-dreams-theme.json";

import { ReportConfig } from "containers/Report/Config/ReportConfig";

export const ECHART_THEMES: Record<string, any> = {
  [ReportConfig.common.CHART_THEMES.VERDANT_SCENT]: verdantScentTheme,
  [ReportConfig.common.CHART_THEMES.OCEAN_GLEAM]: oceanGleamTheme,
  [ReportConfig.common.CHART_THEMES.LAVENDER_BLOOM]: lavenderBloomTheme,
  [ReportConfig.common.CHART_THEMES.APPLE_LEAVES]: appleLeavesTheme,
  [ReportConfig.common.CHART_THEMES.FROZEN_BANANA]: frozenBananaTheme,
  [ReportConfig.common.CHART_THEMES.PLUM_CANDY]: plumCandyTheme,
  [ReportConfig.common.CHART_THEMES.DRY_FIREWOOD]: dryFirewoodTheme,
  [ReportConfig.common.CHART_THEMES.RAINBOW]: rainbowTheme,
  [ReportConfig.common.CHART_THEMES.MYSTIC_DAWN]: mysticDawnTheme,
  [ReportConfig.common.CHART_THEMES.ROSE_RADIANCE]: roseRadianceTheme,
  [ReportConfig.common.CHART_THEMES.CREPE_CAKE]: crepeCakeTheme,
  [ReportConfig.common.CHART_THEMES.BUBBLEGUM]: bubblegumTheme,
  [ReportConfig.common.CHART_THEMES.WARM_MAPLE]: warmMapleTheme,
  [ReportConfig.common.CHART_THEMES.URBAN_SKY]: urbanSkyTheme,
  [ReportConfig.common.CHART_THEMES.DIVERSE_FLAVORS]: diverseFlavorsTheme,
  [ReportConfig.common.CHART_THEMES.COTTON_CANDY]: cottonCandyTheme,
  [ReportConfig.common.CHART_THEMES.TROPICAL_FRUIT]: tropicalFruitTheme,
  [ReportConfig.common.CHART_THEMES.MARKER_MAGIC]: markerMagicTheme,
  [ReportConfig.common.CHART_THEMES.COLOR_CARNIVAL]: colorCarnivalTheme,
  [ReportConfig.common.CHART_THEMES.TWILIGHT_DREAMS]: twilightDreamsTheme,
};

export function registerEchartThemes() {
  Object.entries(ECHART_THEMES).forEach(([name, theme]) => {
    echarts.registerTheme(name, theme);
  });
}

export function getEchartTheme(themeName?: string) {
  if (!themeName) return undefined;
  return ECHART_THEMES[themeName];
}
